// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__2sReR","content":"ManualTimeModal_content__YwVZ6"};